// BasindaCikanHaberler.tsx
import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import PortalApi from "api/PortalApi";
import MasonryImageGrid from "components/yenimahalle/MasonryImageGrid";
import { slugify } from "utils/slugify";

interface NewsItem {
  id: number;
  header: string;
  imageUrl: string;
}

const BasindaCikanHaberler: React.FC = () => {
  const [newsItems, setNewsItems] = useState<NewsItem[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await PortalApi.getLastNewsInPress();
      if (response && response.news) {
        const mappedItems: NewsItem[] = response.news.map((item: any) => ({
          id: item.id,
          header: item.header,
          imageUrl: item.imageUrl,
        }));
        setNewsItems(mappedItems);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout>
      <BasicHeader
        headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe"
        headingLine2=""
      />
      <MasonryImageGrid
        items={newsItems}
        onItemClick={(item) =>{
            const url = `/BasindaCikanHaberler/${slugify(item.header)}/${item.id}`;
          window.open(url, "_blank", "noopener,noreferrer");
        }}
      />
    </Layout>
  );
};

export default BasindaCikanHaberler;
